import React from "react"
import { Check, Eye, File } from "lucide-react"
import { formatMoney } from "@/utils/utils"
import { Button } from "components/ui/button"
import { WalletTransaction } from "@/types/TransactionsType"
import { getPaymentMethodConfig } from "@/utils/transactions/utils"

type CreditDemandItemsProps = {
  transaction: WalletTransaction
  highlightItemsColor?: "purple" | "green" | "red"
  onView: () => void
  onValidateStart: () => void
  onRejectionStart: () => void
}

const CreditDemandItem = ({
                            transaction,
                            highlightItemsColor = "purple",
                            onView,
                            onValidateStart,
                            onRejectionStart,
                          }: CreditDemandItemsProps) => {

  return (
    <>
      <div className="flex items-center justify-between bg-white px-4 py-2 border rounded-xl shadow-sm">
        <div className="flex items-center gap-5">
          <div
            className={`w-16 h-16 bg-${highlightItemsColor}-100 text-${highlightItemsColor}-600 p-3 border border-${highlightItemsColor}-500 rounded-lg flex items-center justify-center`}>
            <span className="">
              <File size={28} />
            </span>
          </div>

          <div className="space-y-1">
            <p className="text-xs text-gray-500">
              Date : {transaction.created_at}
            </p>

            <div className="flex items-center gap-2 flex-wrap">
              <p className="font-semibold text-gray-900">
                {transaction.initiator_name}
              </p>

              {transaction.reference && (
                <span className="text-xs text-gray-400">
                  • {transaction.reference} •
                </span>
              )}

              <span
                className={`px-2.5 py-2 rounded-md bg-${highlightItemsColor}-100 text-${highlightItemsColor}-700 border border-${highlightItemsColor}-500 font-medium`}>
                {getPaymentMethodConfig(transaction!.payment_method!).label}
              </span>
            </div>

            <p className="text-sm text-gray-700">
              <span className="text-gray-500">Montant :</span>{" "}
              <span className="font-semibold">
                {formatMoney(parseFloat(transaction.amount))} F CFA
              </span>
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => onView()}
            className="p-2 rounded-md hover:bg-gray-50"
          >
            <Eye size={18} />
          </button>

          {transaction.needs_validation && (
            <>
              <Button
                onClick={() => onValidateStart()}
              >
                <Check size={16} />
                Valider
              </Button>

              <Button
                variant="destructive"
                onClick={() => onRejectionStart()}
              >
                Rejeter
              </Button>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default CreditDemandItem